module.exports = __webpack_public_path__ + "img/product_66.e1df4f0.webp";